<template></template>

<script setup>
import { watch, onUnmounted } from 'vue';
import { storeToRefs } from 'pinia';

import { useMarketStore } from '@/store/global/market';
const marketStore = useMarketStore();
const { selectedMarket, business_account_id } = storeToRefs(marketStore);

import { useDashboardGeoStore } from '@/store/dashboard/dashboardGeo.js';
const dashboardGeoStore = useDashboardGeoStore();
const { selectedDate, selectedLabelIds } = storeToRefs(dashboardGeoStore);

import { useKeywordsStore } from '@/store/visibility/keywords';
const KeywordsStore = useKeywordsStore();
const { selectedCompetitorsLabel } = storeToRefs(KeywordsStore);

watch(
	selectedMarket,
	async (newMarketId, oldMarketId) => {
		if (newMarketId && newMarketId !== oldMarketId) {
			console.log('Market changed:', newMarketId);
			try {
				await dashboardGeoStore.fetchAllGeoData(newMarketId, true);
			}
			catch (error) {
				console.error('Error fetching data:', error);
			}
		}
	},
	{ immediate: true },
);

watch(selectedCompetitorsLabel, async () => {
	console.log('Competitors changed');
	if (selectedMarket.value) {
		await dashboardGeoStore.fetchAllGeoData(selectedMarket.value, true);
	}
});

watch(selectedLabelIds, async () => {
	console.log('Labels changed');
	if (selectedMarket.value) {
		await dashboardGeoStore.fetchAllGeoData(selectedMarket.value, true);
	}
});
</script>
